// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GoToSignup_wrapper__ZDGlB"};